import React, { memo } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { IExtendedMetric } from "@modules/ServiceProviders/types/serviceProvider.types";
import { MetricCard } from "../MetricCard";
import { MetricProgressBar } from "../MetricProgressBar";
import { MetricProgressFooter } from "../MetricProgressFooter";
import messages from "../messages";

interface ILoyalClienteleCard {
  metric: IExtendedMetric | undefined;
  onClick?: () => void;
}

export const LoyalClienteleCard = memo(({ metric, onClick }: ILoyalClienteleCard) => {
  const value = Number(metric?.value ?? 0);
  const threshold = Number(metric?.threshold ?? 20);
  const reached =
    metric !== undefined && metric.value !== null && value >= threshold;

  const recurringCount =
    metric?.computationDetails?.repeatedClientsCount ?? 0;
  const totalClientsCount =
    metric?.computationDetails?.totalClientsCount ?? 0;

  return (
    <MetricCard
      title={<FormattedMessage {...messages.loyalClienteleTitle} />}
      description={
        <FormattedMessage
          {...messages.minThreshold}
          values={{ value: threshold }}
        />
      }
      state={reached ? "reached" : "not-reached"}
      onClick={onClick}
      percentage={value}
      footer={
        <MetricProgressFooter
          text={
            <FormattedMessage
              {...messages.recurringFooter}
              values={{ count: recurringCount, total: totalClientsCount }}
            />
          }
        />
      }
    >
      <MetricProgressBar value={value} threshold={threshold} />
    </MetricCard>
  );
});

LoyalClienteleCard.displayName = "LoyalClienteleCard";
